import { useQuery } from '@tanstack/react-query';
import { get } from '../services/axiosInstance';
import Helper from '../utils/Helper';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import * as axiosInstance from "../services/axiosInstance";

const useEDepositData = (token) => {
    const dispatch = useDispatch();

    return useQuery({
        queryKey: ["depositData"],
        queryFn: async () => {
            try {
                const response = await axiosInstance.get('clientarea/deposit/config', dispatch);
                return response;
            } catch (e) {
                Helper.handleHttpError(e, dispatch);
                throw e;
            }
        },
        retryDelay: 15000,
        enabled: !_.isEmpty(token),
    });
};

export default useEDepositData;